import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

export default function BreadcrumbNavigation({ customCrumbs }) {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    function generateBreadcrumbs() {
        const breadcrumbs = [
            {
                to: '/',
                label: <HomeIcon sx={{ fontSize: '1.2rem', verticalAlign: 'middle' }} />,
            },
        ];

        if (customCrumbs) {
            return [...breadcrumbs, ...customCrumbs];
        }

        let path = '';
        pathnames.forEach((name, index) => {
            path += `/${name}`;
            const isLast = index === pathnames.length - 1;

            breadcrumbs.push({
                to: path,
                label: name.charAt(0).toUpperCase() + name.slice(1),
                isLast,
            });
        });

        return breadcrumbs;
    }

    const breadcrumbs = generateBreadcrumbs();

    // Add schema.org markup for breadcrumbs
    const breadcrumbList = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': breadcrumbs.map((crumb, index) => ({
            '@type': 'ListItem',
            'position': index + 1,
            'item': {
                '@id': `https://getborrowed.com${crumb.to}`,
                'name': typeof crumb.label === 'string' ? crumb.label : 'Home'
            }
        }))
    };

    return (
        <>
            <script type="application/ld+json">
                {JSON.stringify(breadcrumbList)}
            </script>

            <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
                {breadcrumbs.map((crumb, index) => {
                    if (crumb.isLast) {
                        return (
                            <Typography key={crumb.to} color="text.primary" aria-current="page">
                                {crumb.label}
                            </Typography>
                        );
                    }

                    return (
                        <Link
                            key={crumb.to}
                            component={RouterLink}
                            to={crumb.to}
                            color="inherit"
                            underline="hover"
                        >
                            {crumb.label}
                        </Link>
                    );
                })}
            </Breadcrumbs>
        </>
    );
}
